/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.37
 * @license MIT
 * @copyright (c) 2017-2021, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _typeof from '@babel/runtime-corejs3/helpers/esm/typeof';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import { cleanSourceExtraParams, ARCGIS_EXTRA_PARAMS } from '../ol-ext';
import { isEqual, pick } from '../util/minilo';
import { makeWatchers } from '../util/vue-helpers';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var serialize = function serialize(value) {
  if (value == null) return value;
  return _typeof(value) === 'object' ? _JSON$stringify(value) : value;
};

var arcgisSource = {
  props: {
    /**
     * Extra ArcGIS request parameters
     * todo rename to extraParams
     */
    extParams: Object,
    format: {
      type: String,
      default: 'PNG32'
    },
    layers: String,
    layerDefs: [Object, String],
    dynamicLayers: [Object, String],
    dpi: Number,
    transparent: {
      type: Boolean,
      default: true
    },
    time: String,
    layerTimeOptions: [Object, String],
    gdbVersion: String,
    mapScale: String,
    rotation: Number,
    datumTransformations: [Array, String],
    mapRangeValues: [Array, String],
    layerRangeValues: [Array, String],
    layerParameterValues: [Array, String],
    historicMoment: Number
  },
  computed: {
    // todo rename to cleanExtraParams
    cleanExtParams: function cleanExtParams() {
      return this.extParams ? cleanSourceExtraParams(this.extParams, ARCGIS_EXTRA_PARAMS) : undefined;
    },
    allParams: function allParams() {
      return _objectSpread(_objectSpread({}, this.cleanExtParams), {}, {
        LAYERS: this.layers,
        FORMAT: this.format,
        LAYERDEFS: serialize(this.layerDefs),
        DYNAMICLAYERS: serialize(this.dynamicLayers),
        DPI: this.dpi,
        TRANSPARENT: this.transparent,
        TIME: serialize(this.time),
        LAYERTIMEOPTIONS: serialize(this.layerTimeOptions),
        GDBVERSION: this.gdbVersion,
        MAPSCALE: this.mapScale,
        ROTATION: this.rotation,
        DATUMTRANSFORMATIONS: serialize(this.datumTransformations),
        MAPRANGEVALUES: serialize(this.mapRangeValues),
        LAYERRANGEVALUES: serialize(this.layerRangeValues),
        LAYERPARAMETERVALUES: serialize(this.layerParameterValues),
        HISTORICMOMENT: serialize(this.historicMoment)
      });
    }
  },
  watch: _objectSpread(_objectSpread(_objectSpread({}, makeWatchers(['layers', 'format', 'dpi', 'transparent', 'gdbVersion', 'mapScale', 'rotation', 'historicMoment'], function (prop) {
    return function (value) {
      if (!this.$source) return;
      prop = prop.toUpperCase();
      var params = this.$source.getParams() || {};
      if (isEqual(value, params[value])) return;
      this.$source.updateParams(_defineProperty({}, prop, value));
    };
  })), makeWatchers(['layerDefs', 'dynamicLayers', 'time', 'layerTimeOptions', 'datumTransformations', 'mapRangeValues', 'layerRangeValues', 'layerParameterValues'], function (prop) {
    return function (value) {
      if (!this.$source) return;
      prop = prop.toUpperCase();
      value = serialize(value);
      var params = this.$source.getParams() || {};
      if (isEqual(value, params[value])) return;
      this.$source.updateParams(_defineProperty({}, prop, value));
    };
  })), {}, {
    extParams: function extParams(value) {
      if (!this.$source) return;
      var params = pick(this.$source.getParams() || {}, _Object$keys(value));
      if (isEqual(value, params)) return;
      this.$source.updateParams(value ? cleanSourceExtraParams(value) : undefined);
    }
  })
};

export default arcgisSource;
